import objectPath from "object-path";
import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";

import * as apiCaller from "../../api/apiCaller";
import AppError from "./../../ultis/AppError";

export const GET_LIST_REPORT_CAMPAING = "GET_LIST_REPORT_CAMPAING";
export const GET_LIST_REPORT_CAMPAING_ERROR = "GET_LIST_REPORT_CAMPAING_ERROR";
export const GET_LIST_REPORT_CAMPAING_SUCCESS =
  "GET_LIST_REPORT_CAMPAING_SUCCESS";

export const CAMPAIGN_REPORT_DETAIL = "CAMPAIGN_REPORT_DETAIL";
export const CAMPAIGN_REPORT_DETAIL_ERROR = "CAMPAIGN_REPORT_DETAIL_ERROR";
export const CAMPAIGN_REPORT_DETAIL_SUCCESS = "CAMPAIGN_REPORT_DETAIL_SUCCESS";

export const GET_LIST_CAMPAIGN_DETAILS = "GET_LIST_CAMPAIGN_DETAILS";
export const GET_LIST_CAMPAIGN_DETAILS_SUCCESS =
  "GET_LIST_CAMPAIGN_DETAILS_SUCCESS";
export const GET_LIST_CAMPAIGN_DETAILS_ERROR =
  "GET_LIST_CAMPAIGN_DETAILS_ERROR";

export const CAMPAIGN_REPORT_BY_HOUR = "CAMPAIGN_REPORT_BY_HOUR";
export const CAMPAIGN_REPORT_BY_HOUR_SUCCESS =
  "CAMPAIGN_REPORT_BY_HOUR_SUCCESS";
export const CAMPAIGN_REPORT_BY_HOUR_ERROR = "CAMPAIGN_REPORT_BY_HOUR_ERROR";

export const CAMPAIGN_CONNECTED_RATE_BY_HOUR =
  "CAMPAIGN_CONNECTED_RATE_BY_HOUR";
export const CAMPAIGN_CONNECTED_RATE_BY_HOUR_SUCCESS =
  "CAMPAIGN_CONNECTED_RATE_BY_HOUR_SUCCESS";
export const CAMPAIGN_CONNECTED_RATE_BY_HOUR_ERROR =
  "CAMPAIGN_CONNECTED_RATE_BY_HOUR_ERROR";

export const CAMPAIGN_REPORT_BY_STAGE = "CAMPAIGN_REPORT_BY_STAGE";
export const CAMPAIGN_REPORT_BY_STAGE_SUCCESS =
  "CAMPAIGN_REPORT_BY_STAGE_SUCCESS";
export const CAMPAIGN_REPORT_BY_STAGE_ERROR = "CAMPAIGN_REPORT_BY_STAGE_ERROR";

export const CAMPAIGN_REPORT_BY_AGENT = "CAMPAIGN_REPORT_BY_AGENT";
export const CAMPAIGN_REPORT_BY_AGENT_ERROR = "CAMPAIGN_REPORT_BY_AGENT_ERROR";
export const CAMPAIGN_REPORT_BY_AGENT_SUCCESS =
  "CAMPAIGN_REPORT_BY_AGENT_SUCCESS";

export const CAMPAIGN_REPORT_BY_DATE = "CAMPAIGN_REPORT_BY_DATE";
export const CAMPAIGN_REPORT_BY_DATE_ERROR = "CAMPAIGN_REPORT_BY_DATE_ERROR";
export const CAMPAIGN_REPORT_BY_DATE_SUCCESS =
  "CAMPAIGN_REPORT_BY_DATE_SUCCESS";
/**
 * Reducer
 */

const initialState = {
  report: [],
  error: false,
  campaign: {},
  loading: false,
  campaignDetail: {},
  campaignReportByHour: [],
  campaignConnectedRateByHour: [],
  campaignByStage: [],
  campaignByAgent: [],
  campaignByDate: [],
};

export const campaignReducer = (state = initialState, action) => {
  switch (action.type) {
    //get list
    case GET_LIST_REPORT_CAMPAING:
      return {
        ...state,
        loading: true,
      };
    case GET_LIST_REPORT_CAMPAING_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
      };
    case GET_LIST_REPORT_CAMPAING_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //campaign list
    case CAMPAIGN_REPORT_DETAIL:
      return {
        ...state,
      };
    case CAMPAIGN_REPORT_DETAIL_SUCCESS:
      return {
        ...state,
        campaign: action.payload,
      };
    case CAMPAIGN_REPORT_DETAIL_ERROR:
      return {
        ...state,
        error: action.error,
      };

    //list detail
    case GET_LIST_CAMPAIGN_DETAILS:
      return {
        ...state,
      };
    case GET_LIST_CAMPAIGN_DETAILS_SUCCESS:
      return {
        ...state,
        campaignDetail: action.payload,
      };
    case GET_LIST_CAMPAIGN_DETAILS_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //byhour
    case CAMPAIGN_REPORT_BY_HOUR:
      return {
        ...state,
      };
    case CAMPAIGN_REPORT_BY_HOUR_SUCCESS:
      return {
        ...state,
        campaignReportByHour: action.payload,
      };
    case CAMPAIGN_REPORT_BY_HOUR_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //connected
    case CAMPAIGN_CONNECTED_RATE_BY_HOUR:
      return {
        ...state,
      };
    case CAMPAIGN_CONNECTED_RATE_BY_HOUR_SUCCESS:
      return {
        ...state,
        campaignConnectedRateByHour: action.payload,
      };
    case CAMPAIGN_CONNECTED_RATE_BY_HOUR_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //by stage
    case CAMPAIGN_REPORT_BY_STAGE:
      return {
        ...state,
      };
    case CAMPAIGN_REPORT_BY_STAGE_SUCCESS:
      return {
        ...state,
        campaignByStage: action.payload,
      };
    case CAMPAIGN_REPORT_BY_STAGE_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //cby agent
    case CAMPAIGN_REPORT_BY_AGENT:
      return {
        ...state,
        loading: true,
      };
    case CAMPAIGN_REPORT_BY_AGENT_SUCCESS:
      return {
        ...state,
        campaignByAgent: action.payload,
        loading: false,
      };
    case CAMPAIGN_REPORT_BY_AGENT_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    //by date
    case CAMPAIGN_REPORT_BY_DATE:
      return {
        ...state,
        loading: true,
      };
    case CAMPAIGN_REPORT_BY_DATE_SUCCESS:
      return {
        ...state,
        campaignByDate: action.payload,
        loading: false,
      };
    case CAMPAIGN_REPORT_BY_DATE_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      };
    default:
      return state;
  }
};

/**
 * Action
 */
export const getListReportCampaign = (order, limit, skip, where) => ({
  type: GET_LIST_REPORT_CAMPAING,
  data: {
    order,
    limit,
    skip,
    where,
  },
});

export const getListCampaignReportDetail = (id) => ({
  type: GET_LIST_CAMPAIGN_DETAILS,
  data: {
    id,
  },
});

export const campaignReportByHour = (from, to, campaignId) => ({
  type: CAMPAIGN_REPORT_BY_HOUR,
  data: {
    from,
    to,
    campaignId,
  },
});

export const campaignReportByAgent = (from, to, campaignId, agentGroupId) => ({
  type: CAMPAIGN_REPORT_BY_AGENT,
  data: {
    from,
    to,
    campaignId,
    agentGroupId,
  },
});

export const campaignReportByDate = (from, to, campaignId) => ({
  type: CAMPAIGN_REPORT_BY_DATE,
  data: {
    from,
    to,
    campaignId,
  },
});

export const campaignConnectedRateByHour = (from, to) => ({
  type: CAMPAIGN_CONNECTED_RATE_BY_HOUR,
  data: {
    from,
    to,
  },
});

export const campaignReportDetail = (id) => ({
  type: CAMPAIGN_REPORT_DETAIL,
  data: {
    id,
  },
});

export const campaingReportByStage = (from, to, campaignId) => ({
  type: CAMPAIGN_REPORT_BY_STAGE,
  data: {
    from,
    to,
    campaignId,
  },
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      getListReportCampaign,
      campaignReportDetail,
      getListCampaignReportDetail,
      campaignReportByHour,
      campaignConnectedRateByHour,
      campaingReportByStage,
      campaignReportByAgent,
      campaignReportByDate,
    },
    dispatch
  );
};

/**
 * Apis
 */

const getListReportCampaignApi = (order, limit, skip, where) => {
  return apiCaller.getLogs("/mini-crm/campaign/report", {
    order,
    limit,
    skip,
    ...where,
  });
};

const getListCampaignReportDetailApi = (id) => {
  return apiCaller.get(`/mini-crm/campaign/${id}`);
};

const campaignReportByHourApi = (from, to, campaignId) => {
  return apiCaller.getData("/mini-crm/campaign/report-campaign-by-hours", {
    from,
    to,
    campaignId,
  });
};

const campaignConnectedRateByHourApi = (from, to) => {
  return apiCaller.getData("/mini-crm/campaign/report/connected-rate-by-hour", {
    from,
    to,
  });
};

const campaingReportByStageApi = (from, to, campaignId) => {
  return apiCaller.getData("/mini-crm/campaign/report/campaign-by-stage", {
    from,
    to,
    campaignId,
  });
};

const campaignReportByAgentApi = (from, to, campaignId, agentGroupId) => {
  return apiCaller.getData("/mini-crm/campaign/report-campaign-by-agent", {
    from,
    to,
    campaignId,
    agentGroupId,
  });
};

const campaignReportByDateApi = (from, to, campaignId) => {
  return apiCaller.getData("/mini-crm/campaign/report-campaign-by-date", {
    from,
    to,
    campaignId,
  });
};
/**
 * sagas
 */

export const getListReportCampaignFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_REPORT_CAMPAING);
    try {
      const res = yield call(
        getListReportCampaignApi,
        action.data.order,
        action.data.limit,
        action.data.skip,
        action.data.where
      );
      yield put({
        type: GET_LIST_REPORT_CAMPAING_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_REPORT_CAMPAING_ERROR, error });
    }
  }
};

export const getCampaignReportDetailFow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_REPORT_DETAIL);
    const campaign = yield select((state) => state.reportCampaign.report);
    if (campaign.length) {
      const _campaign = campaign.filter((c) => c.id == action.data.id);
      if (_campaign.length == 1) {
        const campaignDetail = _campaign[0];
        yield put({
          type: CAMPAIGN_REPORT_DETAIL_SUCCESS,
          payload: campaignDetail,
        });
        continue;
      }
    }
    try {
      const res = yield call(getListReportCampaignApi);
      yield put({
        type: GET_LIST_REPORT_CAMPAING_SUCCESS,
        payload: { ...res.data },
      });
      const _campaign = res.data.filter((c) => c.campaignId == action.data.id);
      if (_campaign.length == 1) {
        const campaignDetail = _campaign[0];
        yield put({
          type: CAMPAIGN_REPORT_DETAIL_SUCCESS,
          payload: campaignDetail,
        });
        continue;
      } else {
        throw new AppError(null, "Không tìm thấy bản ghi này");
      }
    } catch (error) {
      // const history = globalHistory();
      // history.replace(`${process.env.REACT_APP_PATH}/campaign-center/campaign`);
      yield put({ type: CAMPAIGN_REPORT_DETAIL_ERROR, error });
    }
  }
};

export const getListReportCampaignDetailFlow = function* () {
  while (true) {
    const action = yield take(GET_LIST_CAMPAIGN_DETAILS);
    try {
      const res = yield call(getListCampaignReportDetailApi, action.data.id);
      yield put({
        type: GET_LIST_CAMPAIGN_DETAILS_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: GET_LIST_CAMPAIGN_DETAILS_ERROR, error });
    }
  }
};

export const campaignReportByHourFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_REPORT_BY_HOUR);
    try {
      const res = yield call(
        campaignReportByHourApi,
        action.data.from,
        action.data.to,
        action.data.campaignId
      );
      yield put({
        type: CAMPAIGN_REPORT_BY_HOUR_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_REPORT_BY_HOUR_ERROR, error });
    }
  }
};

export const campaignReportByAgentFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_REPORT_BY_AGENT);
    try {
      const res = yield call(
        campaignReportByAgentApi,
        action.data.from,
        action.data.to,
        action.data.campaignId,
        action.data.agentGroupId
      );
      const data = res.data.sort(function (a, b) {
        var n = new Date(b.date).getTime() - new Date(a.date).getTime();
        if (n != 0) {
          return n;
        }
        var m = b.agent.agentGroup.localeCompare(a.agent.agentGroup);
        if (m != 0) {
          return m;
        }
        return a.agent.agentCode - b.agent.agentCode;
      });

      const reportGroups = {
        date: {
          fields: ["date"],
        },
        dateNTeam: {
          fields: ["date", "agent.agentGroup"],
        },
      };
      data.forEach((item) => {
        item.percenCallback =
          item.percenCallback !== null
            ? item.percenCallback.toFixed(2)
            : item.percenCallback;
        item.percenDnd =
          item.percenDnd !== null ? item.percenDnd.toFixed(2) : item.percenDnd;
        item.percenNew =
          item.percenNew !== null ? item.percenNew.toFixed(2) : item.percenNew;
        item.percenNi =
          item.percenNi !== null ? item.percenNi.toFixed(2) : item.percenNi;
        item.percenNmq =
          item.percenNmq !== null ? item.percenNmq.toFixed(2) : item.percenNmq;
        item.percenPtp =
          item.percenPtp !== null ? item.percenPtp.toFixed(2) : item.percenPtp;
        item.percenVm =
          item.percenVm !== null ? item.percenVm.toFixed(2) : item.percenVm;
        item.percenWr =
          item.percenWr !== null ? item.percenWr.toFixed(2) : item.percenWr;
        item.groups = {};
        for (const groupName in reportGroups) {
          // eslint-disable-next-line no-prototype-builtins
          if (reportGroups.hasOwnProperty(groupName)) {
            const value = reportGroups[groupName];
            let foundItemsInGroup = data.filter((i) => {
              let reportGroup = reportGroups[groupName];
              let condition = true;
              if (reportGroup) {
                reportGroup.fields.forEach((field) => {
                  condition &=
                    objectPath.get(i, field) === objectPath.get(item, field);
                });
              }
              return condition;
            });
            let indexInGroup = foundItemsInGroup.indexOf(item);

            item.groups[groupName] = {
              index: indexInGroup,
              count: foundItemsInGroup.length,
            };
          }
        }
      });
      data.unshift(data.pop());
      yield put({
        type: CAMPAIGN_REPORT_BY_AGENT_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_REPORT_BY_AGENT_ERROR, error });
    }
  }
};

export const campaignReportByDateFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_REPORT_BY_DATE);
    try {
      const res = yield call(
        campaignReportByDateApi,
        action.data.from,
        action.data.to,
        action.data.campaignId
      );
      const data = res.data.sort(function (a, b) {
        return new Date(b.date).getTime() - new Date(a.date).getTime();
      });
      data.forEach((item) => {
        item.percenCallback =
          item.percenCallback != null
            ? item.percenCallback.toFixed(2)
            : item.percenCallback;
        item.percenDnd =
          item.percenDnd != null ? item.percenDnd.toFixed(2) : item.percenDnd;
        item.percenNew =
          item.percenNew != null ? item.percenNew.toFixed(2) : item.percenNew;
        item.percenNi =
          item.percenNi != null ? item.percenNi.toFixed(2) : item.percenNi;
        item.percenNmq =
          item.percenNmq != null ? item.percenNmq.toFixed(2) : item.percenNmq;
        item.percenPtp =
          item.percenPtp != null ? item.percenPtp.toFixed(2) : item.percenPtp;
        item.percenVm =
          item.percenVm != null ? item.percenVm.toFixed(2) : item.percenVm;
        item.percenWr =
          item.percenWr != null ? item.percenWr.toFixed(2) : item.percenWr;
      });
      data.unshift(data.pop());
      yield put({
        type: CAMPAIGN_REPORT_BY_DATE_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_REPORT_BY_DATE_ERROR, error });
    }
  }
};

export const campaignConnectedRateByHourFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_CONNECTED_RATE_BY_HOUR);
    try {
      const res = yield call(
        campaignConnectedRateByHourApi,
        action.data.from,
        action.data.to
      );
      yield put({
        type: CAMPAIGN_CONNECTED_RATE_BY_HOUR_SUCCESS,
        payload: { ...res.data },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_CONNECTED_RATE_BY_HOUR_ERROR, error });
    }
  }
};

export const campaingReportByStageFlow = function* () {
  while (true) {
    const action = yield take(CAMPAIGN_REPORT_BY_STAGE);
    try {
      const res = yield call(
        campaingReportByStageApi,
        action.data.from,
        action.data.to,
        action.data.campaignId
      );
      const data = res.data[0].campaignAllocation.sort(function (a, b) {
        return (
          new Date(a.campaignAllocationCreated).getTime() -
          new Date(b.campaignAllocationCreated).getTime()
        );
      });
      yield put({
        type: CAMPAIGN_REPORT_BY_STAGE_SUCCESS,
        payload: { ...data },
      });
    } catch (error) {
      yield put({ type: CAMPAIGN_REPORT_BY_STAGE_ERROR, error });
    }
  }
};
